"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _Section = _interopRequireDefault(require("../components/Section"));

var _uiKit = require("@devsta/ui-kit");

var _components = require("../../../common/components");

var _utils = require("../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Typography(_ref) {
  var typefacesOverview = _ref.typefacesOverview,
      typefaces = _ref.typefaces,
      gotoId = _ref.gotoId,
      setRef = _ref.setRef;
  return /*#__PURE__*/_react.default.createElement(_Section.default, {
    className: "section__type-section",
    gotoId: gotoId,
    setRef: setRef,
    icon: "typography",
    title: "Typography",
    description: typefacesOverview,
    emptyText: "There aren't any fonts added yet"
  }, (0, _lodash.default)(typefaces) ? null : typefaces.map(function (_ref2) {
    var subBrandGroupId = _ref2.subBrandGroupId,
        name = _ref2.name,
        notes = _ref2.notes,
        assetIds = _ref2.assetIds;
    return (0, _lodash.default)(assetIds) ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "section__break",
      key: subBrandGroupId
    }, /*#__PURE__*/_react.default.createElement(_components.FontsStyleHelmet, {
      fontIds: assetIds
    }), name && /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      heading4: true
    }, name), assetIds.map(function (assetId) {
      return /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
        rounded: true,
        key: assetId,
        className: "section__type-section__container container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          fontFamily: (0, _utils.getFontFamily)(assetId)
        },
        className: "section__type-section__container__font-example"
      }, "abcdefghijklmnopqrstuvqxyz"), /*#__PURE__*/_react.default.createElement("p", {
        style: {
          fontFamily: (0, _utils.getFontFamily)(assetId)
        },
        className: "section__type-section__container__font-example"
      }, "ABCDEFGHIJKLMNOPQRSTUVWXUYZ"), /*#__PURE__*/_react.default.createElement("p", {
        style: {
          fontFamily: (0, _utils.getFontFamily)(assetId)
        },
        className: "section__type-section__container__font-example"
      }, "0123456789!@#$%^&*()_+"));
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      noMargin: "top",
      className: "section__type-section__notes"
    }, notes));
  }).filter(Boolean));
}

var _default = (0, _react.memo)(Typography);

exports.default = _default;